module.exports = __webpack_public_path__ + "static/pic14-d3c41f005e97666480c487a755dab703.jpg";